import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import he from './locales/he.json';
import en from './locales/en.json';

// Helper to get language from localStorage or cookie
function getInitialLanguage() {
  if (typeof window !== 'undefined') {
    const local = localStorage.getItem('i18nextLng');
    if (local) return local;
    const match = document.cookie.match(/i18nextLng=([^;]+)/);
    if (match) return match[1];
  }
  return 'he';
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      he: {
        translation: he,
      },
      en: {
        translation: en,
      },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'he',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'cookie', 'querystring', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupQuerystring: 'lang',
      lookupCookie: 'i18nextLng',
      lookupLocalStorage: 'i18nextLng',
    },
  });

// Set initial direction
document.documentElement.dir = i18n.language === 'he' ? 'rtl' : 'ltr';

// Listen for language changes
i18n.on('languageChanged', (lng) => {
  document.documentElement.dir = lng === 'he' ? 'rtl' : 'ltr';
});

export default i18n; 